import React, { useState, useEffect } from 'react';
import axios from "axios";
import {
  Box,
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AdminLayout from './Admin_Layout/AdminLayout';
import { useNavigate } from 'react-router-dom';

const OfferingsTable = () => {
  const [offeringData, setOfferingData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOfferings = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/weoffer`);

        // Axios already parses JSON, use response.data directly
        setOfferingData(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching offerings:", error);
      }
    };

    fetchOfferings();
  }, []);

  const handleEdit = (offering) => {
    console.log('edit butotn clicked...' + offering.link)
    navigate('/admin-dashboard/edit-books/update-books/specific', { state: { update: true, formData: offering } });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/weoffer/${id}`, {
          method: 'DELETE',
        });

        if (!response.ok) {
          throw new Error('Failed to delete the item.');
        }

        // Optionally update the state to reflect the change in the UI
        setOfferingData((prevData) => prevData.filter((item) => item.id !== id));

        alert('Item deleted successfully!');
      } catch (error) {
        console.error('Error deleting item:', error);
        alert('Failed to delete the item. Please try again.');
      }
    }
  };

  return (
    <AdminLayout>
      <Box sx={{ p: 4 }}>
        <Container maxWidth="lg">
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h4" gutterBottom sx={{ mt: 5 }}>
              Offerings
            </Typography>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Course Name</strong></TableCell>
                    <TableCell><strong>Description</strong></TableCell>
                    <TableCell><strong>Grade</strong></TableCell>
                    <TableCell><strong>Chapters</strong></TableCell>
                    <TableCell><strong>Periods</strong></TableCell>
                    <TableCell><strong>Image</strong></TableCell>
                    <TableCell><strong>Actions</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {offeringData.map((offering, index) => (
                    <TableRow key={index}>
                      <TableCell>{offering.courseName}</TableCell>
                      <TableCell>{offering.description}</TableCell>
                      <TableCell>{offering.grade}</TableCell>
                      <TableCell>{offering.chapterCount}</TableCell>
                      <TableCell>{offering.periods}</TableCell>
                      <TableCell>
                        {offering.image ? (
                          <img
                            src={`${offering.image}`}
                            alt={offering.courseName}
                            style={{ width: 100, height: 60, objectFit: 'cover', borderRadius: '4px' }}
                          />
                        ) : (
                          'No Image'
                        )}
                      </TableCell>
                      <TableCell>
                        <IconButton
                          color="primary"
                          onClick={() => handleEdit(offering)}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="primary"
                          onClick={() => handleDelete(offering._id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Container>
      </Box>
    </AdminLayout>
  );
};

export default OfferingsTable;
